module.exports = __webpack_public_path__ + "static/media/kaching.645af864.mp3";